// Aggregates every product across the site into one lookup for the product detail page
import { topPicks, newArrivals } from "./mock";
import { categoryPages } from "./mockCategories";

const CATEGORY_META = {
  "toys-games": { label: "Toys & Games", path: "/toys-games" },
  "learning-education": { label: "Learning & Education", path: "/learning-education" },
  gifts: { label: "Gifts", path: "/gifts" },
  "shop-by-age": { label: "Shop by Age", path: "/shop-by-age" },
};

const buildCatalog = () => {
  const map = new Map();

  const add = (product, category) => {
    const key = String(product.id);
    if (!map.has(key)) {
      map.set(key, { ...product, category: category.label, categoryPath: category.path });
    }
  };

  topPicks.forEach((p) => add(p, CATEGORY_META["toys-games"]));
  newArrivals.forEach((p) => add(p, CATEGORY_META["toys-games"]));
  Object.entries(categoryPages).forEach(([slug, cfg]) => {
    const meta = CATEGORY_META[slug] || CATEGORY_META["toys-games"];
    cfg.products.forEach((p) => add(p, meta));
  });

  return map;
};

const catalog = buildCatalog();

export const getProductById = (id) => catalog.get(String(id)) || null;

export const getRelatedProducts = (product, count = 4) => {
  if (!product) return [];
  const all = Array.from(catalog.values());
  const sameCategory = all.filter(
    (p) => String(p.id) !== String(product.id) && p.categoryPath === product.categoryPath && p.name !== product.name
  );
  const others = all.filter(
    (p) => String(p.id) !== String(product.id) && p.categoryPath !== product.categoryPath && p.name !== product.name
  );
  const pool = [...sameCategory, ...others];
  const seen = new Set();
  const result = [];
  for (const p of pool) {
    if (!seen.has(p.name)) {
      seen.add(p.name);
      result.push(p);
    }
    if (result.length >= count) break;
  }
  return result;
};

export const getDefaultDescription = (product) =>
  product.description ||
  `${product.name} is a premium quality toy from the Adhira & Appa Toys curated collection. Thoughtfully selected by our child experts, it inspires imagination, builds skills and creates joyful play memories – made from 100% child-safe, non-toxic materials.`;

export const getHighlights = (product) =>
  product.highlights || [
    "100% child-safe & non-toxic materials",
    "Quality tested & expertly curated",
    "Encourages imagination & skill development",
    "Perfect for gifting on birthdays & special occasions",
  ];
